import React, { useState, useRef, useEffect } from "react";
import { isMobile } from "react-device-detect";
import { withTranslation } from "react-i18next";

const WeightGainCalculatorForm = (props) => {
    let componentData = props.componentData; // layout service data
    let weightGainData = props.weightGainData; // parent prop to take inputs
    const { t } = props; // for dictionary phrases

    const [prePregnancyWeight, setPrePregnancyWeight] = useState();
    const [weightUnit, setWeightUnit] = useState("");
    const [weightId, setWeightId] = useState("");
    const [showWeightUnits, setShowWeightUnits] = useState(false);
    const [defaultWeightUnit, setDefaultWeightUnit] = useState("");
    const [currentWeek, setCurrentWeek] = useState();
    const [currentWeekId, setCurrentWeekId] = useState("");
    const [currentWeekErrorMsg, setCurrentWeekErrorMsg] = useState("");
    const [isExpectingTwins, SetIsExpectingTwins] = useState(false);
    const [isValidated, setIsValidated] = useState(false);

    const wrapperRefWeightUnit = useRef(null);

    useEffect(() => {
        setDefaultWeightUnit(
            componentData?.WeightUnit[0]?.fields?.WeightUnitLabel?.value
        );
        setWeightUnit(
            componentData?.WeightUnit[0]?.fields?.WeightUnitLabel?.value
        );
        setWeightId(componentData?.WeightUnit[0]?.id);
    }, [componentData]);

    // useEffect(() => {
    //     console.log("new unit: ", weightUnit);
    // }, [weightUnit]);

    useEffect(() => {
        weightGainData(
            prePregnancyWeight,
            weightUnit,
            weightId,
            currentWeek,
            currentWeekId,
            isExpectingTwins
        );
    }, [
        prePregnancyWeight,
        weightUnit,
        weightId,
        currentWeek,
        currentWeekId,
        isExpectingTwins,
    ]);

    useEffect(() => {
        if (
            prePregnancyWeight > 0 &&
            currentWeek >=
                componentData?.PregnancyWeek[0]?.fields?.Week?.value &&
            currentWeek <=
                componentData?.PregnancyWeek[
                    componentData?.PregnancyWeek?.length - 1
                ]?.fields?.Week?.value
        ) {
            setIsValidated(true);
        } else {
            setIsValidated(false)
        }
        if(isValidated) {
            document.getElementById("btn-calculate").disabled = false;
        } else {
            document.getElementById("btn-calculate").disabled = true;
        }
    }, [prePregnancyWeight, currentWeek, isValidated]);

    useEffect(() => {
        if (
            currentWeek >
                componentData?.PregnancyWeek[
                    componentData?.PregnancyWeek?.length - 1
                ]?.fields?.Week?.value ||
            currentWeek < componentData?.PregnancyWeek[0]?.fields?.Week?.value
        ) {
            setCurrentWeekErrorMsg(
                `Pregnancy week should be between ${
                    componentData?.PregnancyWeek[0]?.fields?.Week?.value
                } and ${
                    componentData?.PregnancyWeek[
                        componentData?.PregnancyWeek?.length - 1
                    ]?.fields?.Week?.value
                }`
            );
        } else {
            setCurrentWeekErrorMsg("");
        }
    }, [currentWeek])

    // useEffect(() => {
    //     console.log("prePregnancyWeight: ", prePregnancyWeight);
    //     console.log("weightUnit: ", weightUnit);
    //     console.log("weightId: ", weightId);
    //     console.log("currentWeek: ", currentWeek);
    //     console.log("isExpectingTwins: ", isExpectingTwins);
    // }, [prePregnancyWeight, weightUnit, weightId, currentWeek, isExpectingTwins]);

    const weightUnitDropDown = () => {
        showWeightUnits ? setShowWeightUnits(false) : setShowWeightUnits(true);
    };

    const setWeightUnitDetails = (item) => {
        let oldWeightUnit = weightUnit;

        setDefaultWeightUnit(item.fields.WeightUnitLabel.value);
        setWeightUnit(item.fields.WeightUnitLabel.value);
        setShowWeightUnits(false);
        setWeightId(item.id);
        
        // change weight field value based on unit selected
        // console.log(oldWeightUnit);
        if(oldWeightUnit.toLowerCase() === "kgs") {
            
            setPrePregnancyWeight(
                Math.round(
                    (prePregnancyWeight * 2.205 + Number.EPSILON) * 100
                ) / 100
            );
        } else if (oldWeightUnit.toLowerCase() === "lbs") {
            setPrePregnancyWeight(Math.round(
                ((prePregnancyWeight / 2.205) + Number.EPSILON) * 100
            ) / 100);
        }
    };

    const handleCurrentWeekDetails = (e) => {
        setCurrentWeek(Number(e.target.value));
        for (let i in componentData?.PregnancyWeek) {
            if (
                componentData?.PregnancyWeek[i]?.fields?.Week?.value ===
                e.target.value
            ) {
                setCurrentWeekId(componentData?.PregnancyWeek[i]?.id);
            }
        }
    }

    return (
        <>
            <div className="row mx-md-3">
                <div className={isMobile ? "col-12" : "col-md-8 col-sm-12"}>
                    <div className="form-group">
                        <label
                            htmlFor="prePregnancyWeight"
                            className="d-flex align-items-center"
                        >
                            {componentData?.PrepregnacyWeightLabel?.value}
                            <a
                                className="ttlink"
                                alt={
                                    componentData?.PrepregnacyWeightLabel?.value
                                }
                            >
                                <i className="fa fa-question-circle"></i>
                                <span>
                                    Enter{" "}
                                    {
                                        componentData?.PrepregnacyWeightLabel
                                            ?.value
                                    }
                                </span>
                            </a>
                        </label>
                        <input
                            type="number"
                            step=".1"
                            className="form-control"
                            id="prePregnancyWeight"
                            placeholder={t(
                                "WeightGainCalculator_WeightPlaceholder"
                            )}
                            value={prePregnancyWeight || ""}
                            onChange={(e) =>
                                setPrePregnancyWeight(Number(e.target.value))
                            }
                        />
                    </div>
                </div>
                <div className={isMobile ? "col-12" : "col-md-4 col-sm-12"}>
                    <div className="form-group">
                        <label htmlFor="weightUnit" className="invisible">
                            {defaultWeightUnit}
                        </label>
                        <div className="brand-select">
                            <div className="custom-select-dropdown">
                                <div className="select-box--box">
                                    <div className="select-box--container">
                                        <div
                                            className="select-box--selected-item"
                                            onClick={weightUnitDropDown}
                                            ref={wrapperRefWeightUnit}
                                        >
                                            <div
                                                className={
                                                    !showWeightUnits
                                                        ? "select-box-selected-item-text-div"
                                                        : "select-box-selected-item-text-div-close"
                                                }
                                            >
                                                <span
                                                    style={{
                                                        textTransform:
                                                            "capitalize",
                                                    }}
                                                    className="select-box-selected-item-text"
                                                >
                                                    {defaultWeightUnit?.toLowerCase()}
                                                </span>
                                            </div>
                                            <div
                                                className="select-box--arrow"
                                                name="select-box--name"
                                            >
                                                <span
                                                    name="drop-down-arrow"
                                                    className={`${
                                                        showWeightUnits
                                                            ? "select-box--arrow-up fa fa-angle-up"
                                                            : "select-box--arrow-down fa fa-angle-down"
                                                    }`}
                                                ></span>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: showWeightUnits
                                                    ? "block"
                                                    : "none",
                                            }}
                                            className="select-box--items"
                                        >
                                            {componentData?.WeightUnit?.map(
                                                (item, index) => {
                                                    return (
                                                        <div
                                                            className={
                                                                defaultWeightUnit ===
                                                                item.fields
                                                                    .WeightUnitLabel
                                                                    .value
                                                                    ? "select-div selected"
                                                                    : "select-div"
                                                            }
                                                            key={index}
                                                            onClick={() =>
                                                                setWeightUnitDetails(
                                                                    item
                                                                )
                                                            }
                                                        >
                                                            <p className="nameListItem">
                                                                {" "}
                                                                {
                                                                    item.fields
                                                                        .WeightUnitLabel
                                                                        .value
                                                                }
                                                            </p>
                                                        </div>
                                                    );
                                                }
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mx-md-3">
                <div
                    className={
                        isMobile ? "col-12" : "col-md-12 col-sm-12 col-12"
                    }
                >
                    <div className="form-group">
                        <label htmlFor="currentWeek">
                            {componentData?.WeekLabel?.value}
                            <a
                                className="ttlink"
                                alt={
                                    componentData?.PrepregnacyWeightLabel?.value
                                }
                            >
                                <i className="fa fa-question-circle"></i>
                                <span>
                                    Enter {componentData?.WeekLabel?.value}
                                </span>
                            </a>
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            id="currentWeek"
                            placeholder="1"
                            value={currentWeek || ""}
                            onChange={(e) => handleCurrentWeekDetails(e)}
                        />
                        {currentWeekErrorMsg.length > 0 ? (
                            <small className="text-danger">*{currentWeekErrorMsg}</small>
                        ) : null}
                    </div>
                </div>
            </div>
            <div className="row mx-md-3">
                <div
                    className={
                        isMobile ? "col-12" : "col-md-12 col-sm-12 col-12"
                    }
                >
                    <div className="form-check">
                        <input
                            className="form-check-input"
                            type="checkbox"
                            id="isExpectingTwins"
                            style={{ accentColor: "red" }}
                            onChange={() =>
                                SetIsExpectingTwins(!isExpectingTwins)
                            }
                        />
                        <label
                            className="form-check-label"
                            htmlFor="isExpectingTwins"
                        >
                            {componentData?.ExpectingTwinLabel?.value}
                        </label>
                    </div>
                </div>
            </div>
        </>
    );
};

export default withTranslation()(WeightGainCalculatorForm);
